import { Bloc } from "@lib/bloc/Bloc"
import { ServiceItemForm } from "@model/serviceRequests/ServiceItemForm"
import { workRequestToServiceItemForm } from "@service/workRequests/MainWorkRequestService"
import { WorkRequestService } from "@service/workRequests/WorkRequestService"

export type AddExistingServiceItemsDialogState = {
    isOpen: boolean
    availableItems: ServiceItemForm[]
    isLoading: boolean
}

export class AddExistingServiceItemsDialogBloc extends Bloc<AddExistingServiceItemsDialogState> {
    constructor(private workRequestService: WorkRequestService) {
        super({ isOpen: false, availableItems: [], isLoading: false })
    }

    async load(assetId: number) {
        this.update({ isLoading: true })
        try {
            const [notDismissedWorkRequestsOutcome] = await Promise.all([
                this.workRequestService.fetchNotDismissedWorkRequestsForAsset(assetId, true, true),
            ])

            if (notDismissedWorkRequestsOutcome.isError()) throw notDismissedWorkRequestsOutcome.error

            const items = notDismissedWorkRequestsOutcome.value
                .sort((a, b) => {
                    // Sort by workOrderId first (null/0 items first)
                    const aHasWorkOrder = a.workOrderId && a.workOrderId > 0 ? 1 : 0
                    const bHasWorkOrder = b.workOrderId && b.workOrderId > 0 ? 1 : 0
                    if (aHasWorkOrder !== bHasWorkOrder) {
                        return aHasWorkOrder - bHasWorkOrder // Items without workOrderId come first
                    }
                    // If both have same workOrderId status, sort by id descending
                    return b.id - a.id
                })
                .map((wr, idx) => workRequestToServiceItemForm(wr, 1000 + idx))

            this.update({ availableItems: items, isLoading: false })
        } catch (err) {
            console.error("Failed to load existing items", err)
            this.update({ availableItems: [], isLoading: false })
        }
    }

    close() {
        this.update({ isOpen: false })
    }

    async selectItem(item: ServiceItemForm, onSelected: (item: ServiceItemForm) => void) {
        onSelected(item)
        this.close()
    }
}
